import createReactClass from 'create-react-class'
import React from 'react'
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs'
import ReactJson from 'react-json-view'
import {propEq, filter} from 'ramda'
import ReportTablePanel from './report-table-panel'
import DecisionTreePanel from './decision-tree-panel'
import MonitoringEventsPanel from './monitoring-events-panel'
import ViewURLPanel from '../view-url-button/view-url-panel'
import Select from '../select-dropdown'
import './report-panel.scss'

export default createReactClass({
  getInitialState () {
    return {
      selectedDecisionTree: '', // for dropdown state
      displayedDecisionTree: '', // for displayed decision tree
    }
  },

  componentDidMount () {
    this.props.getDecisionTreeList()
    if (this.props.location.search) {
      let ggsId = this.props.location.search.substring(1)
      this.props.getCompanyReport(ggsId)
      this.props.getEvents(ggsId)
    }
    if (this.props.monitoring.portfolios && this.props.monitoring.portfolios.length === 0) {
      this.props.getPortfolios()
    }
  },

  backToSearchPage () {
    this.props.history.push('/search')
  },

  changeDecisionTree (e) {
    this.setState({selectedDecisionTree: e.target.value})
  },

  getDecisionTree () {
    if (this.props.location.search && this.state.selectedDecisionTree) {
      let companyId = this.props.location.search.substring(1)
      this.props.getDecisionTreeDetails(this.state.selectedDecisionTree, companyId)
    }
  },

  renderDecisionTreeOptions () {
    return this.props.decisionTree.list.map((tree, index) => {
      return <option key={index} value={tree.GUID}>{tree.friendlyName || 'Unnamed Tree'}</option>
    })
  },

  renderDecisionTree () {
    if (this.props.decisionTree.list && this.props.decisionTree.list.length > 0) {
      return (
        <div className='decision-tree'>
          <div className='select-wrapper'>
            <select id='decision-tree-select' name="decision-tree" value={this.state.selectedDecisionTree || 'Select'}
              onChange={this.changeDecisionTree}>
              <option value=''>Select...</option>
              {this.renderDecisionTreeOptions()}
            </select>
          </div>
          <button className='cs-secondary-button' onClick={() => {
            this.setState({displayedDecisionTree: this.state.selectedDecisionTree}, () => {
              this.getDecisionTree()
            })
          }}>
            Get Decision
          </button>
        </div>
      )
    }
  },

  changePortfolio (val) {
    let id = this.getSelectedPortfolio('portfolioId', val, 'portfolioId')
    this.props.changePortfolio(id)
  },

  deleteCompany () {
    if (this.props.location.search) {
      let companyId = this.props.location.search.substring(1)
      this.props.deleteCompany(companyId)
    }
  },

  addCompany () {
    if (this.props.location.search) {
      let companyId = this.props.location.search.substring(1)
      this.props.addCompany(companyId)
    }
  },

  getSelectedPortfolio (prop, val, key) {
    let items = filter(propEq(prop, val), this.props.monitoring.portfolios)
    return items.length > 0 ? items[0][key] : 0
  },

  renderPortfolioSection () {
    if (this.props.monitoring.portfolios.length > 0) {
      return <div className='pull-right'>
        <div className='portfolis-section'>
          <Select selected={this.props.monitoring.selectedPortfolio}
            onChange={this.changePortfolio} data={this.props.monitoring.portfolios}/>
          <button className='cs-secondary-button' onClick={this.addCompany}>Add to portfolio</button>
          <button className='cs-primary-button' onClick={this.deleteCompany}>Delete from portfolio</button>
        </div>
      </div>
    }
  },

  renderViewUrl () {
    return (<div className='pull-right'>
      <ViewURLPanel />
    </div>)
  },

  getSelectedDecisionTree () {
    const name = filter(propEq('GUID', this.state.displayedDecisionTree), this.props.decisionTree.list)
    return name.length > 0 ? name[0] : ''
  },

  renderJsonData () {
    const {error, dataError, decisionTreeData} = this.props.decisionTree
    return error || dataError || decisionTreeData
  },

  render () {
    return (
      <div className="container">
        <div className="report-view-panel">
          {this.props.report.isLoading
            ? <div className='loader-ctr'><span className="loading"></span></div>
            : <div>
              <div className='button-sets-block'>
                <button className='cs-secondary-button' onClick={this.backToSearchPage}>
                  <span className='fa fa-caret-left'/>
                  Back
                </button>
                {this.renderDecisionTree()}
                {this.renderPortfolioSection()}
                {this.renderViewUrl()}
              </div>
              <Tabs>
                <TabList>
                  <Tab>Card View</Tab>
                  <Tab>Raw JSON</Tab>
                </TabList>
                <TabPanel>
                  <DecisionTreePanel selectedTree={this.getSelectedDecisionTree()} {...this.props.decisionTree} />
                  <MonitoringEventsPanel {...this.props.monitoring.company}/>
                  <ReportTablePanel {...this.props.report} />
                </TabPanel>
                <TabPanel>
                  {(this.props.decisionTree.error || this.state.displayedDecisionTree)
                    ? <div>
                      <h4>Decision Tree</h4>
                      <div id='decision-tree-json' className='raw-json-view'>
                        {this.props.decisionTree.dataLoader
                          ? <div className='loader-ctr'><span className="loading"></span></div>
                          : <ReactJson
                            src={this.renderJsonData()}
                            collapsed={1}/>
                        }
                      </div>
                    </div> : null}
                  <div>
                    <h4>Monitoring Events</h4>
                    <div id='events-json' className='raw-json-view'>
                      <ReactJson src={this.props.monitoring.company.error ? this.props.monitoring.company.error : this.props.monitoring.company.events}
                        collapsed={1}/>
                    </div>
                  </div>
                  <div>
                    <h4>Company Report</h4>
                    <div id='report-json' className='raw-json-view'>
                      <ReactJson src={this.props.report.error ? this.props.report.error : this.props.report.companyReport}
                        collapsed={1}/>
                    </div>
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          }
        </div>
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/report-page/report-panel.js